/*
 * @Author: LiuLiXue QQ:136890965 
 * @Date: 2017-12-22 13:50:50 
 * @Last Modified by: LiuLiXue
 * @Last Modified time: 2017-12-22 14:04:27
 */
<template>
  <div class="top">
    <div class="title" v-text="title">
    </div>
    <el-button type="primary" v-text="btnTitle" @click="_click"/>
  </div>
</template>

<script>
export default {
  name: 'titleBtn',
  props: {
    title: {
      type: String,
      default: '内容管理'
    },
    btnTitle: {
      type: String,
      default: '内容管理'
    }
  },
  methods: {
    _click() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
  .top{
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>





// WEBPACK FOOTER //
// src/components/TitleButton.vue